// src/pages/dashboard/DashboardEntryPoint.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; // Ensure this path is correct
import TalentDashboardLayout from './talent/TalentDashboardLayout';
import DirectorProducerDashboardLayout from './directorproducer/DirectorProducerDashboardLayout';
import CastingDirectorDashboardLayout from './castingdirector/CastingDirectorDashboardLayout';
import { Spinner } from 'react-bootstrap';

const DashboardEntryPoint = () => {
    const { user, loading: authLoading, isAuthenticated } = useAuth(); // Get isAuthenticated as well

    // Log initial state for debugging
    // console.log("DashboardEntryPoint RENDER - authLoading:", authLoading, "isAuthenticated:", isAuthenticated, "user:", user);

    if (authLoading) {
        // console.log("DashboardEntryPoint: Auth is loading...");
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
                <Spinner animation="border" variant="danger" />
                <span className="ms-2">Loading User Data...</span>
            </div>
        );
    }

    // After loading, check if authenticated and user data is present
    if (!isAuthenticated || !user) {
        console.warn("DashboardEntryPoint: User not authenticated or user data missing after loading. Redirecting to login. User:", user, "IsAuth:", isAuthenticated);
        return <Navigate to="/login" state={{ message: "Authentication required to access the dashboard." }} replace />;
    }

    // At this point, user is authenticated and user object exists
    const roleCode = user.roleCode ? String(user.roleCode) : null;
    // console.log("DashboardEntryPoint: Processing with roleCode:", roleCode, "User:", user);

    if (!roleCode) {
        console.error("DashboardEntryPoint: Authenticated user is missing roleCode. User data:", user);
        return <Navigate to="/login" state={{ message: "User role is not defined. Please contact support." }} replace />;
    }

    // The switch statement is crucial for rendering the correct dashboard
    switch (roleCode) {
        case '300': // Talent
            console.log("DashboardEntryPoint: Rendering TalentDashboardLayout for roleCode 300");
            return <TalentDashboardLayout />;
        case '200': // Director/Producer
            return <DirectorProducerDashboardLayout />;
        case '400': // Casting Director
            return <CastingDirectorDashboardLayout />;
        default:
            console.warn("DashboardEntryPoint: Unrecognized roleCode:", roleCode, ". User:", user);
            return <Navigate to="/login" state={{ message: `Invalid user role ('${roleCode}'). Please contact support.` }} replace />;
    }
};

export default DashboardEntryPoint;